export const COUNT = 'count'
export const DETAILS = 'details'
export const TYPE = 'storageType'